export const possibleTypes = {
  SeriesSegment: ['SeriesSegmentText', 'SeriesSegmentLegacy'],
  ContentNode: ['ContentFolder', 'ContentItem'],
  MutationPayload: ['LogEventPayload', 'SaveMHFTResponsePayload'],
};
